import React, { useEffect, useState, Dispatch, SetStateAction } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import {
  Grid,
  Paper,
  Table,
  TableContainer,
  TableBody,
  TableRow,
  TableCell,
  TextField,
  Button,
  TableHead,
} from '@material-ui/core';
import GroupTitle from '../GroupTitle';
import { XYDeviceSelectItem, XYItemSelectItem, XY_CMP_GROUP_SET } from '../../../../function/GroupDataModel';
import ItemComboBox, { ComboBoxItemType } from '../../../atoms/ComboBox/ItemComboBox';
import { useMemo } from 'react';
import { debug } from '../../../../function/LogLapper';

type XYDeviceItemProps = {
  selectList: XYDeviceSelectItem[];
  deviceIdx: number;
  groupNo: number;
  plcNoX: number;
  setNoX: number;
  plcNoY: number;
  setNoY: number;
  plcSetFunc: (devIdx: number, plcX: number, setX: number, plcY: number, setY: number) => void;
};

const useStyles = makeStyles(
  createStyles({
    tableStyle: {
      width: '400px',
      borderStyle: 'none',
    },
    rowStyle: {
      borderStyle: 'none',
    },
    cellStyle: {
      borderStyle: 'none',
    },
    cellName: {
      width: '140px',
    },
    cellData: {
      width: '220px',
    },
    selectNo: {
      width: '120px',
    },
    selectName: {
      width: '200px',
    },
    dropdownStyle: {
      maxHeight: 300,
    },
    gridStyle: {
      borderStyle: 'solid',
    },
    tableItem: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      orderBottomStyle: 'inset',
      borderLeftStyle: 'solid',
      borderRightStyle: 'solid',
      textAlign: 'center',
      minWidth: '80px',
      height: '8px',
      padding: '1px',
    },
  })
);

const XYDeviceItem: React.FC<XYDeviceItemProps> = (props: XYDeviceItemProps) => {
  const classes = useStyles();
  const [devIdx, setDevIdx] = useState<number>(0);
  const [devCombos, setDevCombos] = useState<ComboBoxItemType[]>([]);
  const [itemXCombos, setItemXCombos] = useState<ComboBoxItemType[]>([]);
  const [itemNameCombos, setItemNameCombos] = useState<ComboBoxItemType[]>([]);
  const [itemNameNoX, setItemNameNoX] = useState<number>(0);
  const [itemNameNoY, setItemNameNoY] = useState<number>(0);
  const [itemXIdx, setItemXIdx] = useState<number>(0);
  const [itemYCombos, setItemYCombos] = useState<ComboBoxItemType[]>([]);
  const [itemYIdx, setItemYIdx] = useState<number>(0);
  const [listItem, setListItem] = useState<XYItemSelectItem[]>([]);
  const checkCombos: ComboBoxItemType[] = []

  const careteDevCombos = (): ComboBoxItemType[] => {
    console.debug(['careteDevCombos - ', 'props', props, props.selectList]);
    props.selectList.forEach((r) => console.debug([r]));
    const defPara: ComboBoxItemType = { index: 0, name: '---' };
    const devList = [defPara].concat(
      props.selectList.map<ComboBoxItemType>((sel, idx) => {
        return { index: idx + 1, name: sel.DEV_NO, tag: sel };
      })
    );

    return devList;
  };
  const searchDevCombosIndex = (devIndex: number, devList: ComboBoxItemType[]): number => {
    let ans = devList.find((r) => {
      let tgt = r.tag as XYDeviceSelectItem;
      if (tgt == null) return false;
      if (tgt.DEV_INDEX === devIndex) return true;
      return false;
    });
    return ans == null ? 0 : ans.index;
  };

  /**
   *計測種別のコンボボックスリストを作成
   * @returns
   */
  const crateItemNameCombos = (devConbo: ComboBoxItemType): ComboBoxItemType[] => {
    if (devConbo == null) return [];
    const v = devConbo.tag as XYDeviceSelectItem;
    if (v == null) return [];

    const tmp = v.ItemSelects.filter(function (x, i, array) {
      return (
        v.ItemSelects.findIndex(function (y) {
          return y.SPEED === x.SPEED && y.NAME_NO === x.NAME_NO;
        }) === i
      );
    });

    const itemNameList = tmp.map<ComboBoxItemType>((r, idx) => {
      return { index: idx, name: r.MES_NAME, tag: r };
    });
    return itemNameList;
  };

  const searchItemNameCombosIndex = (
    itemSelectDatas: XYDeviceSelectItem,
    itemNameConbos: ComboBoxItemType[],
    plcNo: number,
    setNo: number
  ): number => {
    if (itemSelectDatas == null) return 0;

    let itemTarget = itemSelectDatas.ItemSelects.find((r) => r.PLC_NO === plcNo && r.SET_NO === setNo);
    if (itemTarget == null) return 0;

    let ans = itemNameConbos.find((r) => {
      let tgt = r.tag as XYItemSelectItem;
      if (tgt == null) return false;
      if (tgt.NAME_NO === itemTarget?.NAME_NO && tgt.SPEED === itemTarget.SPEED) return true;
      return false;
    });
    return ans == null ? 0 : ans.index;
  };

  const crateItemCombos = (devCombo: ComboBoxItemType, itemNameCombo: ComboBoxItemType): ComboBoxItemType[] => {
    if (devCombo == null || itemNameCombo == null) return [];

    const v = itemNameCombo.tag as XYItemSelectItem;
    const vv = devCombo.tag as XYDeviceSelectItem;
    if (v == null || vv == null) return [];

    // //項目x選択Index検索
    const tmp = vv.ItemSelects.filter((r) => {
      if (r.NAME_NO === v.NAME_NO && r.SPEED === v.SPEED) return true;
      return false;
    });

    const itemList = tmp.map<ComboBoxItemType>((r, idx) => {
      return { index: idx, name: r.ITM_NAME, tag: r };
    });

    return itemList;
  };

  const searchItemCombosIndex = (itemConbos: ComboBoxItemType[], plcNo: number, setNo: number): number => {
    let ans = itemConbos.find((r) => {
      let tgt = r.tag as XYItemSelectItem;
      if (tgt == null) return false;
      if (tgt.PLC_NO === plcNo && tgt.SET_NO === setNo) return true;
      return false;
    });
    return ans == null ? 0 : ans.index;
  };

  useEffect(() => {
    if (props.selectList == null) return;
    const devCombos = careteDevCombos();
    const devListIndex = searchDevCombosIndex(props.deviceIdx, devCombos);
    const v = devCombos[devListIndex].tag as XYDeviceSelectItem;

    const itemNameCombos = crateItemNameCombos(devCombos[devListIndex]);
    const itemNameComboIndexX = searchItemNameCombosIndex(v, itemNameCombos, props.plcNoX, props.setNoX);
    const itemNameComboIndexY = searchItemNameCombosIndex(v, itemNameCombos, props.plcNoY, props.setNoY);

    const itemCombosX = crateItemCombos(devCombos[devListIndex], itemNameCombos[itemNameComboIndexX]);
    const itemCombosY = crateItemCombos(devCombos[devListIndex], itemNameCombos[itemNameComboIndexY]);

    const itemComboIndexX = searchItemCombosIndex(itemCombosX, props.plcNoX, props.setNoX);
    const itemComboIndexY = searchItemCombosIndex(itemCombosY, props.plcNoY, props.setNoY);

    const lstItem = v == null ? [] : v.ItemSelects;

    setListItem(lstItem);

    setDevCombos(devCombos);
    setDevIdx(devListIndex);

    setItemNameCombos(itemNameCombos);
    setItemNameNoX(itemNameComboIndexX);
    setItemNameNoY(itemNameComboIndexY);

    //X項目コンボボックスアイテムセット
    setItemXCombos(itemCombosX);
    setItemYCombos(itemCombosY);

    setItemXIdx(itemComboIndexX);
    setItemYIdx(itemComboIndexY);

    console.debug([
      'useEffect - selectList ',
      'props',
      props,
      'devCombos',
      devCombos,
      'devListIndex',
      devListIndex,
      'itemNameCombos',
      itemNameCombos,
      'itemNameComboIndexX',
      itemNameComboIndexX,
      'itemNameComboIndexY',
      itemNameComboIndexY,
      'itemCombosX',
      itemCombosX,
      'itemCombosY',
      itemCombosY,
      'itemComboIndexX',
      itemComboIndexX,
      'itemComboIndexY',
      itemComboIndexY,
    ]);
  }, [props.selectList, props.groupNo]);

  /**
   * 機器番号コンボボックス選択変更
   * @param idx
   */
  const deviceChange = (idx: number) => {
    if (idx === 0) {
      props.plcSetFunc(0, 0, 0, 0, 0);

      setDevIdx(idx);
      setItemNameCombos([]);
      setItemNameNoX(0);
      setItemNameNoY(0);

      setItemXCombos([]);
      setItemYCombos([]);
      setItemXIdx(0);
      setItemYIdx(0);

      return;
    } else {
      const itemNameCombos = crateItemNameCombos(devCombos[idx]);
      const itemCombosX = crateItemCombos(devCombos[idx], itemNameCombos[0]);
      const itemCombosY = crateItemCombos(devCombos[idx], itemNameCombos[0]);

      let tgt = itemCombosX === checkCombos ? { PLC_NO: 0, SET_NO: 0 } : (itemCombosX[0].tag as XYItemSelectItem);

      setDevIdx(idx);

      setItemNameCombos(itemNameCombos);
      setItemNameNoX(0);
      setItemNameNoY(0);

      //X項目コンボボックスアイテムセット
      setItemXCombos(itemCombosX);
      setItemYCombos(itemCombosY);

      setItemXIdx(0);
      setItemYIdx(0);

      props.plcSetFunc(props.selectList[idx - 1].DEV_INDEX, tgt.PLC_NO, tgt.SET_NO, tgt.PLC_NO, tgt.SET_NO);
    }
  };

  /**
   * 計測種別Xコンボボックス選択変更
   * @param idx
   */
  const itemNameChangeX = (index: number) => {
    const itemCombosX = crateItemCombos(devCombos[devIdx], itemNameCombos[index]);

    setItemNameNoX(index);
    //X項目コンボボックスアイテムセット
    setItemXCombos(itemCombosX);
    setItemXIdx(0);

    let tgtX = itemCombosX === checkCombos ? { PLC_NO: 0, SET_NO: 0 } : (itemCombosX[0].tag as XYItemSelectItem);
    let tgtY = itemYCombos === checkCombos ? { PLC_NO: 0, SET_NO: 0 } : (itemYCombos[itemYIdx].tag as XYItemSelectItem);

    props.plcSetFunc(props.selectList[devIdx - 1].DEV_INDEX, tgtX.PLC_NO, tgtX.SET_NO, tgtY.PLC_NO, tgtY.SET_NO);
  };

  /**
   * 計測種別Yコンボボックス選択変更
   * @param idx
   */
  const itemNameChangeY = (index: number) => {
    const itemCombosY = crateItemCombos(devCombos[devIdx], itemNameCombos[index]);

    setItemNameNoY(index);
    //X項目コンボボックスアイテムセット
    setItemYCombos(itemCombosY);
    setItemYIdx(0);

    let tgtX = itemXCombos === checkCombos ? { PLC_NO: 0, SET_NO: 0 } : (itemXCombos[itemXIdx].tag as XYItemSelectItem);
    let tgtY = itemCombosY === checkCombos ? { PLC_NO: 0, SET_NO: 0 } : (itemCombosY[0].tag as XYItemSelectItem);

    props.plcSetFunc(props.selectList[devIdx - 1].DEV_INDEX, tgtX.PLC_NO, tgtX.SET_NO, tgtY.PLC_NO, tgtY.SET_NO);
  };

  const itemChangeX = (idx: number) => {
    let tgtX = itemXCombos === checkCombos ? { PLC_NO: 0, SET_NO: 0 } : (itemXCombos[idx].tag as XYItemSelectItem);
    let tgtY = itemYCombos === checkCombos ? { PLC_NO: 0, SET_NO: 0 } : (itemYCombos[itemYIdx].tag as XYItemSelectItem);

    setItemXIdx(idx);

    props.plcSetFunc(props.selectList[devIdx - 1].DEV_INDEX, tgtX.PLC_NO, tgtX.SET_NO, tgtY.PLC_NO, tgtY.SET_NO);
  };

  const itemChangeY = (idx: number) => {
    let tgtX = itemXCombos === checkCombos ? { PLC_NO: 0, SET_NO: 0 } : (itemXCombos[itemXIdx].tag as XYItemSelectItem);
    let tgtY = itemYCombos === checkCombos ? { PLC_NO: 0, SET_NO: 0 } : (itemYCombos[idx].tag as XYItemSelectItem);

    setItemYIdx(idx);
    props.plcSetFunc(props.selectList[devIdx - 1].DEV_INDEX, tgtX.PLC_NO, tgtX.SET_NO, tgtY.PLC_NO, tgtY.SET_NO);
  };

  return (
    <TableRow>
      <TableCell className={classes.tableItem}>
        <ItemComboBox
          itemList={devCombos}
          label=""
          value={devIdx}
          onChangeEvent={(e) => {
            if (typeof e.target.value === 'string') {
              deviceChange(parseInt(e.target.value));
            }
          }}
        />
      </TableCell>
      <TableCell className={classes.tableItem}>
        <ItemComboBox
          itemList={itemNameCombos}
          label=""
          value={itemNameNoX}
          onChangeEvent={(e) => {
            if (typeof e.target.value === 'string') {
              itemNameChangeX(parseInt(e.target.value));
            }
          }}
        />
      </TableCell>
      <TableCell className={classes.tableItem}>
        <ItemComboBox
          itemList={itemXCombos}
          label=""
          value={itemXIdx}
          onChangeEvent={(e) => {
            if (typeof e.target.value === 'string') {
              itemChangeX(parseInt(e.target.value));
            }
          }}
        />
      </TableCell>
      <TableCell className={classes.tableItem}>
        <ItemComboBox
          itemList={itemNameCombos}
          label=""
          value={itemNameNoY}
          onChangeEvent={(e) => {
            if (typeof e.target.value === 'string') {
              itemNameChangeY(parseInt(e.target.value));
            }
          }}
        />
      </TableCell>
      <TableCell className={classes.tableItem}>
        <ItemComboBox
          itemList={itemYCombos}
          label=""
          value={itemYIdx}
          onChangeEvent={(e) => {
            if (typeof e.target.value === 'string') {
              itemChangeY(parseInt(e.target.value));
            }
          }}
        />
      </TableCell>
    </TableRow>
  );
};

export default XYDeviceItem;
